import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../common-services/response-container";
import { Observable } from "rxjs";
import { Batch } from "./model/extraction-batch";
import { tap, timeout } from "rxjs/operators";

@Injectable()
export class ExtractionService {


    constructor(private http: HttpClient) {
    }

    getOrdersEligibleForExtraction(selectedLabId: string): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/orders/' + selectedLabId
        return this.http.get<BBResponseContainer>(url);
    }

    // `statusList` should be a comma (,) separated list of statuses. DO NOT SEND LIST/ARRAY object here
    getBatchesEligibleForExtraction(labId: string, statusList: string, startDate: string, endDate: string): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/batches';
        let requestParam = new HttpParams().set('labId', labId).set('statusList', statusList).set('startDate', startDate).set('endDate', endDate);
        const options = { params: requestParam };
        return this.http.get<BBResponseContainer>(url, options);
    }
    createBatch(selectedLabId: string, newInitials: string, puid: string) {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/batch';
        let requestParam = new HttpParams().set('labId', selectedLabId).set('puid', puid).set('initials', newInitials);
        return this.http.post<BBResponseContainer>(url, requestParam);
    }
    searchBatchUsingField(selectedLabId: string, fieldsForSearch: string, searchValue: any) {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/search/batch';
        let requestParam = new HttpParams().set('labId', selectedLabId).set('fieldToSearch', fieldsForSearch).set('searchValue', searchValue);
        const options = { params: requestParam };
        return this.http.get<BBResponseContainer>(url, options);
    }
    searchOrder(selectedLabId: string, searchField: string, searchValue: string) {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/search/order';
        let requestParam = new HttpParams().set('labId', selectedLabId).set('searchField', searchField).set('searchValue', searchValue);
        const options = { params: requestParam };
        return this.http.get<BBResponseContainer>(url, options);
    }

    updateBatch(batch: Batch) {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/batch';
        return this.http.put<BBResponseContainer>(url, batch);
    }

    validateBarcode(labId: string, barcode: string): Observable<BBResponseContainer>  {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/sample/validate/' + labId + '/' + barcode;
        return this.http.get<BBResponseContainer>(url);
    }

    scanSave(batch: Batch): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/sample/save';
        return this.http.put<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout));
    }
    
    removeSamples(batch: Batch): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/sample/remove';
        return this.http.put<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout));
    }

    commentSave(commentUdpateRequest: any): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'extraction/sample/comments';
        return this.http.patch<BBResponseContainer>(url, commentUdpateRequest).pipe(timeout(environment.defaultTimeout));
    }
}